







































import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import { CreatorService } from "@scrile/api-provider/dist/api/CreatorServicesProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIconButton from "@/components/BaseIconButton";
import PaymentConfirmation from "@/components/PaymentConfirmation";
import { CreatorServiceCategoryNamesMap } from "@/features/CreatorService/const";
import CreatorServiceTag from "../components/CreatorServiceTag.vue";
import { resolveCreatorTagsByIds } from "../helpers";
import useCreatorServicesPurchase from "../hooks/useCreatorServicesPurchase";

export default defineComponent({
  name: "CreatorServicePurchaseCard",
  components: { CreatorServiceTag, PaymentConfirmation, BaseButton, BaseIconButton },
  props: {
    userId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const item = ref<CreatorService | null>(null);
    const purchasing = ref(false);
    const showPaymentConfirmation = ref(false);

    const { purchase, purchaseInfoDetails } = useCreatorServicesPurchase(item);

    const price = computed(() => formatMoneyString(item.value?.price ?? 0));

    const previewSrc = computed(() =>
      item.value?.preview ? MediaFilesController.getImageThumbnail(item.value.preview.urlPart, 100) : null
    );

    const categoryLabel = computed(() => {
      if (!item.value) return "";
      return CreatorServiceCategoryNamesMap[item.value.category] || item.value.category;
    });

    const resolvedTags = computed(() => resolveCreatorTagsByIds(item.value?.tags || []));

    const fetchService = async () => {
      const response = await providers.CreatorServicesProvider.search({
        data: {
          userId: props.userId,
          deleted: false,
          size: 1,
          sort: "ID,DESC",
        },
      });
      item.value = response.result[0] ?? null;
    };

    const onUnlock = () => {
      if (!item.value || purchasing.value) return;
      showPaymentConfirmation.value = true;
    };

    const onPurchase = useAuthorisedOnly(async () => {
      try {
        purchasing.value = true;
        const { success } = await purchase();
        if (success) {
          emitter.emit(EVENTS.NOTIFICATION_SHOW, {
            text: $t("Thank you for your purchase"),
            position: "top",
          });
          showPaymentConfirmation.value = false;
          emit("close");
        }
      } finally {
        purchasing.value = false;
      }
    });

    watch(() => props.userId, fetchService, { immediate: true });

    return {
      item,
      purchasing,
      previewSrc,
      categoryLabel,
      resolvedTags,
      purchaseInfoDetails,
      showPaymentConfirmation,
      price,
      onUnlock,
      onPurchase,
    };
  },
});
